module.exports = __webpack_public_path__ + "img/P2-B1.10ec4709.svg";